import $ from 'jquery';

(function () {

    $(document).ready(() => {

        $('#search-office').on('submit', function(e) {

            e.preventDefault()

            const submit = $(this).closest('form').find(':submit');

            submit.prop('disabled', true)

            submitSearchForm(submit)

        })

        $(document).on('click','#search-modal-office .multi li a', function(e) {
            e.preventDefault()

            const target = $(e.target).text()
            const submit = $('#search-office').find(':submit')

            submitSearchForm(submit, target)
        });


        function submitSearchForm(submit, searchTerm = '') {

            let data = {
                action: 'get_district_from_post'
            }

            $("#search-office input").each(function() {
                data[$(this).attr('name')] = searchTerm.length === 0 ? $(this).val() : searchTerm
            });

            $.ajax({
                url: ajaxurl,
                type: 'post',
                data: data,

                success: function(response) {

                    if(response['#search-modal-office']) {
                        
                        $('#select-office-modal .modal-dialog').addClass('result')

                        if(!response.match) {
                            $('#select-office-modal .modal-dialog').removeClass('result')
                        }

                        if($('#search-modal-office').length) {
                            $('#search-modal-office').replaceWith(response['#search-modal-office'])
                        } else {
                            $('#search-bar-office').after(response['#search-modal-office'])
                        }

                    }

                    submit.prop('disabled', false)
                },

                error: function(response) {
                    submit.prop('disabled', false)
                }

            });

        }


    })
    
})()
